import React, { useState } from 'react';
import { ReactComponent as EyeIcon } from '../../assets/IconsColurs/IconsGeneral/show.svg';
import { ReactComponent as EyeOffIcon } from '../../assets/IconsColurs/IconsGeneral/hide.svg';
import { ReactComponent as Abajo } from '../../assets/IconsColurs/IconsGeneral/chevronDown.svg';
import COP from '../../assets/currency/copu.png';
import USD from '../../assets/currency/usd.png';

const BalanceCard = ({ imgSrc, balanceCurrency, loading, setCurrencyCoin }) => {
  const [seeBalance, setSeeBalance] = useState(true);
  const [currency, setCurrency] = useState('COP');
  const [open, setOpen] = useState(false);

  const pressEye = () => setSeeBalance((prev) => !prev);
  const handleSelect = (selectedCurrency) => {
    setCurrency(selectedCurrency);
    setOpen(false);
    setCurrencyCoin(selectedCurrency);
  };

  return (
    <div
      className="w-full h-full rounded-[12px] p-4 text-white flex flex-col justify-center"
      style={{
        backgroundImage: "url('https://media.giphy.com/media/rbwoL7kN0M8hnPMDkC/giphy.gif')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Skeleton del Selector de Moneda */}
          {loading ? (
            <div className="w-24 h-10 bg-gray-700 rounded-lg animate-pulse"></div>
          ) : (
            <div className="relative">
              <div
                className="w-24 h-10 px-2 py-2 bg-transparent rounded-lg flex gap-2 justify-center items-center cursor-pointer"
                onClick={() => setOpen(!open)}
              >
                <img src={currency === 'COP' ? COP : USD} width={20} height={20} alt="moneda" />
                <p className="text-[14px] font-bold">{currency}</p>
                <Abajo className={`w-4 h-4 transition-transform duration-500 ${open ? 'rotate-180' : ''}`} />
              </div>

              {open && (
                <div className="absolute top-12 left-0 w-32 bg-[#2b2a32] shadow-lg rounded-lg z-50 text-white p-2">
                  <button
                    className="w-full px-4 py-3 text-left flex items-center gap-2 rounded-lg hover:bg-[#33333b]"
                    onClick={() => handleSelect('COP')}
                  >
                    <img src={COP} width={20} height={20} alt="COP" />
                    <span>COP</span>
                  </button>
                  <button
                    className="w-full px-4 py-3 text-left flex items-center gap-2 rounded-lg hover:bg-[#33333b]"
                    onClick={() => handleSelect('USD')}
                  >
                    <img src={USD} width={20} height={20} alt="USD" />
                    <span>USD</span>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Balance Section */}
      <div className="flex flex-row items-center mt-4 gap-3">
        {loading ? (
          <div className="h-4 w-40 bg-gray-700 rounded animate-pulse"></div>
        ) : (
          <>
            <p className="text-xs font-bold uppercase leading-4 tracking-[2px]">
              BALANCE TOTAL (APRÓX)
            </p>
            <button onClick={pressEye} className="w-5 h-5 cursor-pointer">
              {seeBalance ? <EyeOffIcon className="w-5 h-5" /> : <EyeIcon className="w-5 h-5" />}
            </button>
          </>
        )}
      </div>

      {/* Balance Value */}
      <div className="mt-1">
        {loading ? (
          <div className="h-8 w-32 bg-gray-700 rounded animate-pulse"></div>
        ) : (
          <p className="text-[28px] font-normal tracking-tighter leading-8">
            {seeBalance ? balanceCurrency : "---"}
          </p>
        )}
      </div>
    </div>
  );
};

export default BalanceCard;
